import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-left\">\n<path d=\"M364.66 451.456C370.019 456.837 370.024 465.567 364.672 470.955C359.321 476.343 350.639 476.349 345.28 470.968L135.022 259.819C129.66 254.435 129.659 245.697 135.019 240.311L345.277 29.0352C350.634 23.6524 359.316 23.6553 364.67 29.0417C370.023 34.428 370.02 43.1581 364.663 48.5409L164.114 250.061L364.66 451.456Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol